export default "__VITE_ASSET__ecWZunU5__"